var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":"2"}},[_c('v-text-field',{attrs:{"placeholder":_vm.$t('search'),"hide-details":"","loading":_vm.loading && 'info'},on:{"input":(val) => _vm.$emit('onSearch', val)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }